export default __webpack_public_path__ + "static/img/icon-tutorial-drag.0fb6ed7.png";